import { Icon, Project } from "@nova/protobuf"
import {
    colorValidators,
    createLayerValidator,
    enumValidator,
    genericUpdateLayerValidator,
    jsonValidators,
    latitudeValidators,
    longitudeValidators,
    UnionToTuple,
    updateLayerValidator,
} from "../util"
import { dateAsNumber } from "../../util"
import { createNewLayerFractionalIndex } from "../../util/fractional_indexing"
import { LineWidth } from "@nova/constants"

const urlValidators = [
    {
        validator: (url: string) => url.length > 0,
        error: "URL must be a non-empty string",
    },
]

export const createIconValidator = createLayerValidator(Icon, {
    longitude: {
        validators: longitudeValidators,
        nonNull: true,
    },
    latitude: {
        validators: latitudeValidators,
        nonNull: true,
    },
    url: {
        validators: urlValidators,
        nonNull: true,
    },
    color: { validators: colorValidators },
    parentId: genericUpdateLayerValidator.parentId,
    targetPayload: {
        validators: jsonValidators,
    },
    width: { validators: enumValidator("LineWidth", LineWidth) },
    outline: { validators: colorValidators },
})

export const updateIconValidator = updateLayerValidator(Icon, {
    longitude: {
        validators: longitudeValidators,
        nonNull: true,
    },
    latitude: {
        validators: latitudeValidators,
        nonNull: true,
    },
    url: {
        validators: urlValidators,
        nonNull: true,
    },
    color: { validators: colorValidators },
    width: { validators: enumValidator("LineWidth", LineWidth) },
    outline: { validators: colorValidators },
    size: { validators: [], nonNull: true },
})

export const getDefaultIconCreateArgs = (project: Project, inParentId?: string) => {
    return {
        visible: true,
        createdAt: dateAsNumber(),
        index: createNewLayerFractionalIndex(project, 0, inParentId),
        // parentId would never got autopopulated
        parentId: undefined,
        images: [],
    }
}

export type CreateIconArgs = UnionToTuple<keyof typeof createIconValidator>
export type UpdateIconArgs = UnionToTuple<keyof typeof updateIconValidator>
